
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook para buscar dados de sugestões de anúncios
 * 
 * Busca todas as sugestões de anúncios da clínica do usuário atual,
 * incluindo sugestões pendentes, processando, concluídas e com erro.
 * Usado para exibir o histórico e status das sugestões solicitadas.
 */
export const useAdSuggestionsData = (clinicaId?: string) => {
  return useQuery({
    queryKey: ['ad-suggestions', clinicaId],
    queryFn: async () => {
      const query = supabase
        .from('ad_suggestions')
        .select('*')
        .order('created_at', { ascending: false });

      // Se clinicaId foi fornecido (modo admin), filtrar por essa clínica
      if (clinicaId) {
        query.eq('clinica_id', clinicaId);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Erro ao buscar sugestões de anúncios:', error);
        throw new Error(error.message);
      }

      return data || [];
    },
    enabled: true,
    refetchInterval: 30000, // Atualizar a cada 30 segundos (evitar estouro de egress Supabase)
    refetchOnWindowFocus: false, // Não recarregar a cada vez que troca de aba
  });
};
